<template>
  <div>
    <transition-group
      name="flip-list"
      tag="div"
      class="tags-container"
      :class="{ 'tags-container--error': error }"
    >
      <div
        class="video-tag"
        :class="{ 'video-tag--selected': selectedTags.includes(tag.id) }"
        v-for="tag in sortedTags"
        :key="tag.id"
        @click="toggleTagSelection(tag)"
      >
        {{ tag.name }}
      </div>
    </transition-group>
    <p class="error" v-if="error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "video-tag-selector",

  props: {
    tags: Array,
    error: String,
    value: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      selectedTags: []
    };
  },

  computed: {
    sortedTags() {
      return this.tags
        .map(tag => ({ ...tag, selected: this.selectedTags.includes(tag.id) }))
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .sort((a, b) => (a.selected === b.selected ? 0 : a.selected ? -1 : 1));
    }
  },

  methods: {
    toggleTagSelection({ id }) {
      if (this.selectedTags.includes(id)) {
        this.selectedTags.splice(this.selectedTags.findIndex(x => x === id), 1);
      } else {
        this.selectedTags.push(id);
      }

      this.$emit("input", this.selectedTags);
    }
  },

  beforeMount() {
    this.selectedTags = this.value;
  },

  watch: {
    value(value) {
      this.selectedTags = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-container {
  display: flex;
  color: $grey;
  flex-wrap: wrap;
  border: solid 1px transparent;

  .video-tag {
    cursor: pointer;
    position: relative;
    font-family: $family-sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.5rem;
    letter-spacing: 0.05rem;
    display: inline-block;
    padding: 0.5rem 0.8rem;
    border-radius: $radius-small;
    margin: 0.3rem 0.3rem;
    flex: 1;
    background: $grey-lighter;
    color: $grey;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &--selected {
      background: $primary;
      color: $white;
    }
  }

  &.tags-container--error {
    border: solid 1px $danger;
    border-radius: $radius;
  }
}

.error {
  color: $danger;
  font-size: 0.75rem;
}
</style>
